import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import { wrap, withT } from '../../../../lib/wrappers';
import a from '../../../../redux/actions';
import s from '../../../../redux/selectors';
import LocationAutocomplete from '../../../common/LocationAutocomplete.tsx';

const InputLocation = ({
  selectLocation,
  t,
}) => (
  <div className="cc-component__question" id="get_started__input_location">
    <h4>1. {t('Where do you live?')}</h4>
    <div className="cc-component__question__inner">
      <div id="get_started__suggestions_container" className="cc-component__question">
        <LocationAutocomplete
          placeholder={t('Please enter city or zipcode')}
          identifier="get_started__input_location"
          onLocationSelected={selectLocation}
        />
      </div>
    </div>
  </div>
  );

InputLocation.propTypes = {
  selectLocation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => [].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'selectLocation',
  ]),
  dispatch,
);

export default wrap(
  withT('getStarted'),
  connect(mapStateToProps, mapDispatchToProps),
  InputLocation,
);
